export { BicyclingLayer } from './directives/bicycling-layer';
export { NavigatorGeolocation } from './services/navigator-geolocation';
export { OptionBuilder } from './services/option-builder';
export { NG_MAP_CONFIG_TOKEN, ConfigOption } from './services/config';
export { NgMapApiLoader, NgMapAsyncApiLoader, NgMapAsyncCallbackApiLoader } from './services/api-loader';

export { Ng2MapComponent } from './components/ng2-map.component';
export { InfoWindow } from './components/info-window';
export { CustomMarker } from './components/custom-marker';

export { Circle } from './directives/circle';
export { DataLayer } from './directives/data-layer';
export { DirectionsRenderer } from './directives/directions-renderer';
export { DrawingManager } from './directives/drawing-manager';
export { GeoCoder } from './services/geo-coder';
export { GroundOverlay } from './directives/ground-overlay';
export { HeatmapLayer } from './directives/heatmap-layer';
export { KmlLayer } from './directives/kml-layer';
export { Marker } from './directives/marker';
export { Ng2Map } from './services/ng2-map';
export { PlacesAutoComplete } from './directives/places-auto-complete';
export { Polygon } from './directives/polygon';
export { Polyline } from './directives/polyline';
export { StreetViewPanorama } from './directives/street-view-panorama';
export { TrafficLayer } from './directives/traffic-layer';
export { TransitLayer } from './directives/transit-layer';

export { Ng2MapModule } from './ng2-map.module';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/index.ts